<template>
  <div v-observe-visibility="visibility" class="booking-time booking-step js-booking-step" style="display:none" :id="this.$options._componentTag">
    <h1 class="booking-title">Select the time</h1>
    <div class="booking-steps__wrap">
      <div class="booking-steps__wrap-upper">
        <span v-if="this.getActiveFrequency === 'one-time'" class="booking-label">Available times for <a class="booking-label__link" href="javascript:" @click="triggerBack">{{
            date
          }}</a></span>
        <span v-if="this.getActiveFrequency === 'recurring'" class="booking-label">Available times for your recurring booking</span>
        <span class="val-error js-date-error-time">Please select time slot!</span>
        <!--<div class="booking-steps__wrap-time-btns">-->
        <!--  <a v-for="(item, index) in this.getAvailableTimeSingleBooking" :class="['booking-steps__wrap-time-btn', {'is-active': activeTime == item}]" @click="setTime($event.currentTarget)" href='javascript:;' v-bind:key="index">{{-->
        <!--      item-->
        <!--    }}</a>-->
        <!--</div>-->
        <div class="booking-steps__wrap-time-btns">
          <a class="booking-steps__wrap-time-btn" :class="['booking-steps__wrap-time-btn js-booking-steps__wrap-time-btn', {'is-active': activeTime == '8:00AM'}]" @click="setTime($event.currentTarget)" href='javascript:;'>8:00AM</a>
          <a class="booking-steps__wrap-time-btn" :class="['booking-steps__wrap-time-btn js-booking-steps__wrap-time-btn', {'is-active': activeTime == '9:00AM'}]" @click="setTime($event.currentTarget)" href='javascript:;'>9:00AM</a>
          <a class="booking-steps__wrap-time-btn" :class="['booking-steps__wrap-time-btn js-booking-steps__wrap-time-btn', {'is-active': activeTime == '10:00AM'}]" @click="setTime($event.currentTarget)" href='javascript:;'>10:00AM</a>
          <a class="booking-steps__wrap-time-btn" :class="['booking-steps__wrap-time-btn js-booking-steps__wrap-time-btn', {'is-active': activeTime == '11:00AM'}]" @click="setTime($event.currentTarget)" href='javascript:;'>11:00AM</a>
          <a class="booking-steps__wrap-time-btn" :class="['booking-steps__wrap-time-btn js-booking-steps__wrap-time-btn', {'is-active': activeTime == '12:00PM'}]" @click="setTime($event.currentTarget)" href='javascript:;'>12:00PM</a>
          <a class="booking-steps__wrap-time-btn" :class="['booking-steps__wrap-time-btn js-booking-steps__wrap-time-btn', {'is-active': activeTime == '1:00PM'}]" @click="setTime($event.currentTarget)" href='javascript:;'>1:00PM</a>
          <a class="booking-steps__wrap-time-btn" :class="['booking-steps__wrap-time-btn js-booking-steps__wrap-time-btn', {'is-active': activeTime == '2:00PM'}]" @click="setTime($event.currentTarget)" href='javascript:;'>2:00PM</a>
          <a class="booking-steps__wrap-time-btn" :class="['booking-steps__wrap-time-btn js-booking-steps__wrap-time-btn', {'is-active': activeTime == '3:00PM'}]" @click="setTime($event.currentTarget)" href='javascript:;'>3:00PM</a>
          <a class="booking-steps__wrap-time-btn" :class="['booking-steps__wrap-time-btn js-booking-steps__wrap-time-btn', {'is-active': activeTime == '4:00PM'}]" @click="setTime($event.currentTarget)" href='javascript:;'>4:00PM</a>
          <a class="booking-steps__wrap-time-btn" :class="['booking-steps__wrap-time-btn js-booking-steps__wrap-time-btn', {'is-active': activeTime == '5:00PM'}]" @click="setTime($event.currentTarget)" href='javascript:;'>5:00PM</a>
        </div>
      </div>
      <div class="booking-side__image booking-location__image">
        <img class="media-item booking-side__image-firefox" :src="imagesPath" alt="animation">
        <div class="anim-holder">
          <div class="anim-container anim-container--06" ref="animContainer"></div>
        </div>
      </div>
    </div>
    <div class="booking-steps__wrap-bottom">
      <p class="booking-steps__wrap-bottom-text" v-if="policyText" v-html="policyText"></p>
    </div>
  </div><!-- .booking-location -->
</template>
<script>

import {mapGetters} from 'vuex';
import Global from '../../../js/shared/global';
import lottieWeb from 'lottie-web';

export default {
  props: ['policyText'],
  beforeMount() {
    this.activeTime = Global.readCookie('selectedTime');
  },
  data() {
    return {
      activeTime: null,
      imagesPath: process.env.BASE_URL + 'wp-content/themes/fws-sproost/src/assets/animations/6.png',
      date: Global.readCookie('oneDayDateTime')
    };
  },
  mounted() {
    this.animation();
  },
  methods: {
    animation() {
      setTimeout(() => {
        const animContainer = document.getElementsByClassName('anim-container--06');
        let animation;
        animContainer.forEach(function(el) {
          animation = process.env.BASE_URL + 'wp-content/themes/fws-sproost/src/assets/animations/Icon6.json';
          const anim = lottieWeb.loadAnimation({
            container: el,
              animType: 'svg',
              loop: true,
              autoplay: true,
              path: animation,
              renderer: 'svg',
              rendererSettings: {
                progressiveLoad: true,
              },
          });
          anim.play();
        });
      }, 500);
    },
    visibility(isVisible) {
      if (isVisible) {
        this.date = Global.readCookie('oneDayDateTime');
      }
    },
    setTime(el) {
      const allTimesBtns = document.querySelectorAll('.booking-steps__wrap-time-btn');
      for (let i = 0; i < allTimesBtns.length; i++) {
        allTimesBtns[i].classList.remove('is-active');
      }
      el.classList.add('is-active');
      this.$store.dispatch('setActiveTime', el.innerHTML);
      Global.setCookie('selectedTime', el.innerHTML);
      const error = document.querySelector('#BlockStepTime .js-date-error-time');
      if (error) {
        error.style.display = 'none';
      }
    },
    triggerBack() {
      const btn = document.querySelector('.js-back-step-btn');
      if (!btn) {
        return;
      }
      btn.click();
    }
  },
  computed: {
    ...mapGetters([
      'getCurrentStep',
      'getActiveFrequency',
      'getOneDayDate',
      'getAvailableTimeSingleBooking'
    ])
  },
};
</script>
<style lang="scss" scoped>

.booking-time {

  .booking-label {
    font-size: 20px;
    letter-spacing: 4px;
    margin-bottom: 0;

    span {
      color: $tree-poppy;
    }

    @include mq($lg) {
      margin-bottom: 15px;
    }

    @include mq($md) {
      font-size: 14px;
      margin-bottom: 10px;
    }

    @include mq(500px) {
      margin: 0 auto 10px;
    }
  }
}

.booking-label__link {
  @include mq($xl) {
    display: block;
    width: fit-content;
  }

  @include mq($lg) {
    display: initial;
  }

  @include mq(500px) {
    margin: 0 auto;
    display: block;
  }
}

.booking-steps__wrap-upper {
  max-width: 730px;

  @include mq($lap-large) {
    max-width: 50%;
  }

  @include mq($lg) {
    max-width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}

.booking-location__image {

  @include mq($lg) {
    max-width: 300px;
    margin-bottom: 0;
    margin-top: 40px;
    display: flex;
    justify-content: center;
  }
}

.booking-steps__wrap-time-btns {
  display: flex;
  flex-wrap: wrap;
  margin: 0 -15px;

  @include mq($lg) {
    margin: 0 auto;
    max-width: 510px;
    width: 100%;
    justify-content: center;
  }
}

.booking-steps__wrap-time-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 158px;
  height: 74px;
  border-radius: 10px;
  padding: 0 10px;
  background-color: $royal-blue;
  border: 3px solid $royal-blue;
  color: $white;
  font-family: $font-main;
  font-size: 22px;
  font-weight: 600;
  font-style: normal;
  letter-spacing: normal;
  line-height: 100px;
  text-align: center;
  text-transform: uppercase;
  margin: 30px 15px 0;
  transition: $dur $ease;

  @include mq($xl) {
    width: 120px;
    height: 60px;
    font-size: 19px;
    margin: 20px 10px 0;
  }

  @include mq($phone) {
    width: 100px;
    height: 50px;
    font-size: 16px;
  }

  @include mq(350px) {
    width: 98px;
  }


  &.is-active {
    border: 3px solid $tree-poppy;
    background-color: $white;
    color: $tree-poppy;
  }

  &.is-disabled {
    border: 3px solid $royal;
    background-color: $royal;
    color: $dodger-blue;
    pointer-events: none;
  }

  @include hover {
    border: 3px solid $tree-poppy;
    color: $tree-poppy;
  }
}

.booking-steps__wrap-bottom {
  width: 100%;
  margin-top: 20px;

  @include mq($lg) {
    margin-bottom: 20px;
  }
}

.booking-steps__wrap-bottom-text {
  font-size: 20px;
  font-family: $font-main;
  font-weight: 500;
  font-style: normal;
  letter-spacing: 0.1px;
  line-height: 44px;
  color: $white;
  max-width: 750px;

  @include mq($lg) {
    font-size: 19px;
    line-height: 1.7;
  }

  @include mq($md) {
    font-size: 18px;
  }

  @include mq($phone) {
    font-size: 15px;
  }

  br {

    @include mq($xl) {
      display: none;
    }
  }
}
</style>
